import React from 'react';

import { FullScreenAlert } from 'components/FullScreenAlert';
import { useTranslation } from 'react-i18next';

export const LocalStorageAccessGuard = ({ children }: { children: unknown }) => {
  const { t } = useTranslation();

  const isLocalStorageAvailable = () => {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch {
      return false;
    }
  };

  return !isLocalStorageAvailable() ? (
    <FullScreenAlert
      header={t('APP.LOCAL_STORAGE_ACCESS.TITLE')}
      body={t('APP.LOCAL_STORAGE_ACCESS.MESSAGE')}
      notice={t('APP.LOCAL_STORAGE_ACCESS.NOTICE')}
    />
  ) : (
    <>{children}</>
  );
};
